export class Limits {
    static readonly MAX_AVATAR_FILE_SIZE_B = 10 * 1024 * 1024;
    static readonly MAX_IMPORTED_CONTACTS_FILE_SIZE_B = 5 * 1024 * 1024;
    static readonly MAX_THUMBNAILABLE_FILE_SIZE_B = 50 * 1024 * 1024;
    static readonly MAX_PREVIEWABLE_FILE_SIZE_B = 20 * 1024 * 1024;
}
